import { Link } from 'react-router-dom';

export default function Footer() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/919711165605?text=Hi, I need a bulk quote for printer consumables', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+919711165605';
  };

  const handleEmail = () => {
    window.location.href = 'mailto:Gi2official.in@gmail.com';
  };

  const handleLocation = () => {
    window.open('https://maps.google.com/?q=Delhi,India', '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-16">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Column 1 - Brand */}
          <div className="space-y-4 md:space-y-6">
            <img
              src="https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/400664175eef7daba939234b6dd4e0a2.png"
              alt="GI2 Logo"
              className="h-12 md:h-14 w-auto brightness-0 invert"
            />
            <p className="text-gray-400 text-sm">
              B2B Printer Consumables Supplier
            </p>
            <p className="text-gray-300 text-sm font-semibold">
              <i className="ri-secure-payment-line mr-2"></i>
              GST: 07AAWFG3117C1ZI
            </p>
            <div className="flex items-center gap-4">
              <button
                onClick={handleCall}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-teal-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
              </button>
              <button
                onClick={handleEmail}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-teal-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-xl"></i>
              </button>
              <button
                onClick={handleLocation}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-teal-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-map-pin-line text-xl"></i>
              </button>
              <button
                onClick={handleWhatsApp}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-teal-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </button>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 md:mb-6">Quick Links</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/become-a-dealer" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Become a Dealer
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Product Categories */}
          <div>
            <h3 className="text-lg font-bold mb-4 md:mb-6">Categories</h3>
            <ul className="space-y-2 md:space-y-3 text-sm">
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Laser Toner Cartridges
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Generic Ink
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  OPC Drums
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Toner Powder
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  Lamination Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact & CTA */}
          <div className="space-y-4 md:space-y-6">
            <div>
              <h3 className="text-xl font-bold mb-2">Get Quick Quote</h3>
              <p className="text-gray-400 text-sm mb-4">
                WhatsApp or call for instant response
              </p>
            </div>
            <div className="space-y-3">
              <button
                onClick={handleWhatsApp}
                className="w-full px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                +91-97111-65605
              </button>
              <button
                onClick={handleCall}
                className="w-full px-6 py-3 border-2 border-teal-600 text-teal-400 hover:bg-teal-600 hover:text-white font-semibold rounded-lg transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Call Now
              </button>
            </div>
            <p className="text-gray-400 text-sm">
              <i className="ri-mail-line mr-2"></i>
              Gi2official.in@gmail.com
            </p>
          </div>
        </div>

        {/* Trademark Disclaimer */}
        <div className="py-4 border-t border-gray-800">
          <p className="text-xs text-gray-500 text-center leading-relaxed">
            <i className="ri-information-line mr-1"></i>
            The Brand Name/Model Designations are the property of their respective owners and are used here for identification purposes only.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p className="text-center md:text-left">© 2025 Gi2 Merchants LLP. All rights reserved.</p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <a href="#" className="hover:text-white transition-colors duration-200 whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors duration-200 whitespace-nowrap">
                Terms of Service
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors duration-200 whitespace-nowrap"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
